// extracted by mini-css-extract-plugin
export var modal = "_ci-0";